export default class UploadPhoto {

  constructor(public src: string, public buffer: string, public id: number, public org_filename: string, public private_photo: boolean) {
  }

}